<template>
  <div
    class="content has-text-centered"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <p
      id="selectPlatformText"
      :class="{'float-right': Language == 'fa' || Language == 'ar'}"
    >{{ $t("choose_your_desired_trading_platform_and_settings").tTitle() }}</p>
    <div style="clear:both"></div>

    <!-- MT4 Main Container -->
    <div
      class="accountPlatformContainer"
      :class="{'selected': platform=='mt4', 'float-right': Language == 'fa' || Language == 'ar'}"
      @click="platform='mt4'"
    >
      <div id="mt4Logo"></div>

      <div id="mt4Inputs">
        <span class="select">
          <select
            id="mt4Currency"
            v-model="mt4.currency"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_currency").tTitle() }}</option>
            <option
              v-for="(c, i) in $getCurrencies()"
              :key="i"
              :value="i"
            >{{i}} ({{c.symbol}})</option>
          </select>
        </span>
        <span class="select">
          <select
            id="mt4AccountType"
            v-model="mt4.group"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_account_type").tTitle() }}</option>
            <option
              v-for="(g, i) in mt4.groupOptions"
              :key="i"
              :value="g.name"
            >{{g.display_name}}{{(mt4.currency == '' ? " (" + g.currency + ")" : "")}}</option>
          </select>
        </span>
        <span class="select">
          <select
            id="mt4Leverage"
            v-model="mt4.leverage"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_leverage").tTitle() }}</option>
            <option
              v-for="(l, i) in leverages"
              :key="i"
              :value="l.leverage"
            >1:{{l.leverage}}</option>
          </select>
        </span>
        <span class="select">
          <select v-model="mt4.balance">
            <option
              value
              selected="selected"
            >{{ $t("select_starting_balance").tTitle() }}</option>
            <option value="500">500</option>
            <option value="1000">1,000</option>
            <option value="3000">3,000</option>
            <option value="5000">5,000</option>
            <option value="20000">20,000</option>
            <option value="50000">50,000</option>
            <option value="100000">100,000</option>
          </select>
        </span>
        <!-- label class="label">
          <input id="acceptBonus" type="checkbox" v-model="mt4.acceptBonus" />
          {{ $t("include_account_in_bonus_program").tTitle() }}
        </label-->
      </div>

      <button
        class="button is-primary"
        @click="createTradingAccount('mt4')"
      >{{ $t("create").tUpper() }}</button>
    </div>

    <!-- MT5 Main Container -->
    <div
      class="accountPlatformContainer"
      :class="{'selected': platform=='mt5', 'float-right': Language == 'fa' || Language == 'ar'}"
      @click="platform='mt5'"
    >
      <div id="mt5Logo"></div>

      <div id="mt5Inputs">
        <span class="select">
          <select
            id="mt5Currency"
            v-model="mt5.currency"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_currency").tTitle() }}</option>
            <option
              v-for="(c, i) in $getCurrencies()"
              :key="i"
              :value="i"
            >{{i}} ({{c.symbol}})</option>
          </select>
        </span>
        <span class="select">
          <select
            id="mt5AccountType"
            v-model="mt5.group"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_account_type").tTitle() }}</option>
            <option
              v-for="(g, i) in mt5.groupOptions"
              :key="i"
              :value="g.name"
            >{{g.display_name}}{{(mt5.currency == '' ? " (" + g.currency + ")" : "")}}</option>
          </select>
        </span>
        <span class="select">
          <select
            id="mt5Leverage"
            v-model="mt5.leverage"
          >
            <option
              value
              selected="selected"
            >{{ $t("select_leverage").tTitle() }}</option>
            <option
              v-for="(l, i) in leverages"
              :key="i"
              :value="l.leverage"
            >1:{{l.leverage}}</option>
          </select>
        </span>
        <span class="select">
          <select v-model="mt5.balance">
            <option
              value
              selected="selected"
            >{{ $t("select_starting_balance").tTitle() }}</option>
            <option value="500">500</option>
            <option value="1000">1,000</option>
            <option value="3000">3,000</option>
            <option value="5000">5,000</option>
            <option value="20000">20,000</option>
            <option value="50000">50,000</option>
            <option value="100000">100,000</option>
          </select>
        </span>

      </div>

      <button
        class="button is-primary"
        @click="createTradingAccount('mt5')"
      >{{ $t("create").tUpper() }}</button>
    </div>

    <div class="is-clearfix"></div>

    <error-modal></error-modal>
  </div>
</template>


<script>
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import ErrorModal from '../../components/ErrorModal'

export default {
  components: {
    ErrorModal,
  },
  data() {
    return {
      title: this.$t('create_demo_account').tUpper(),
      name: this.$t('create_demo_account').tUpper(),
      platform: 'mt4',
      version: 'demo',
      leverages: {},
      acceptBonusYN: {
        true: 'yes',
        false: 'no',
      },
      mt4: {
        currency: '',
        group: '',
        groupOptions: {},
        leverage: '',
        acceptBonus: false,
        balance: '',
      },
      mt5: {
        currency: '',
        group: '',
        groupOptions: {},
        leverage: '',
        acceptBonus: false,
        balance: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
    }),
  },
  watch: {
    'mt4.currency'() {
      this.mt4.group = ''
      this.getPlatformAccountGroups(this.platform, this.mt4.currency, this.version)
    },
    'mt4.group'() {
      this.getGroupLeverages(this.mt4.group)

      for (const g in this.mt4.groupOptions) {
        let group = this.mt4.groupOptions[g]

        if (group.name === this.mt4.group) {
          // console.log('Setting leverage to ' + group.default_leverage)
          this.mt4.leverage = group.default_leverage
        }
      }
    },

    'mt5.currency'() {
      this.mt5.group = ''
      this.getPlatformAccountGroups(this.platform, this.mt5.currency, this.version)
    },
    'mt5.group'() {
      this.getGroupLeverages(this.mt5.group)

      for (const g in this.mt5.groupOptions) {
        let group = this.mt5.groupOptions[g]

        if (group.name === this.mt5.group) {
          console.log('Setting leverage to ' + group.default_leverage)
          this.mt5.leverage = group.default_leverage
        }
      }
    },
  },
  mounted() {},
  methods: {
    getPlatformAccountGroups(platform, currency, mode) {
      service
        .post('/account-types/list-filtered', {
          platform: platform,
          currency: currency,
          mode: mode,
        })
        .then(response => {
          if (response.data) {
            if (platform === 'mt4') {
              this.mt4.groupOptions = Object.assign({}, this.$moveInvestorLast(response.data.account_types))
            } else if (platform === 'mt5') {
              this.mt5.groupOptions = Object.assign({}, this.$moveInvestorLast(response.data.account_types))
            }
          }
        })
        .catch(error => {
          console.log(error.response.data)
        })
    },
    getGroupLeverages(group) {
      if (group) {
        service
          .post('/account-types/list-leverages', {
            name: group,
          })
          .then(response => {
            if (response.data) {
              this.leverages = Object.assign({}, response.data.leverages)
            }
          })
          .catch(error => {
            console.log(error.response.data)
          })
      } else {
        this.leverages = {}
        this.mt4.leverage = ''
        this.mt5.leverage = ''
      }
    },
    createTradingAccount(plt) {
      this.platform = plt

      if (this.platform === 'mt4' || this.platform === 'mt5') {
        var platformParameters = {}

        if (this.platform === 'mt4') {
          platformParameters = this.mt4
        }

        if (this.platform === 'mt5') {
          platformParameters = this.mt5
        }

        if (!platformParameters.currency || !platformParameters.group || !platformParameters.leverage) {
          this['errorModal/set']({ active: true, text: this.$t('please_select_an_option') })
          return
        }

        service
          .post('/ta/create-ta-mt', {
            userID: this.User.info.ID,
            platform: this.platform,
            accountType: 'demo',
            currency: platformParameters.currency,
            accountGroup: platformParameters.group,
            leverage: parseInt(platformParameters.leverage),
            demoBalance: parseFloat(platformParameters.balance),
          })
          .then(response => {
            if (response.data.success) {
              this.$toasted.success(this.$t('new_trading_account_message'))
              this.$toasted.success(this.$t('password_generated_for_ta'), { duration: 7000 })
              this.$router.push('/' + (this.Language || 'en') + '/trading-account/list')
            }
          })
      }
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

div.accountPlatformContainer {
  width: 365px;
  min-height: 450px;
  float: left;
  padding: 30px;
  border: solid 1px black;
  margin-right: 50px;
  margin-top: 30px;
  cursor: pointer;

  @media screen and (max-width: $desktop - 1px) {
    float: none;
    margin: 10px auto;
  }

  @media screen and (max-width: $mobile) {
    width: 345px;
  }

  &.selected {
    border: solid 3px #e04ef8;
  }

  div {
    width: 300px;

    @media screen and (max-width: $mobile) {
      width: 280px;
    }
  }

  div#mt4Logo {
    height: 100px;
    background-image: url(../../assets/img/mt4-logo.jpg);
  }

  div#mt5Logo {
    height: 100px;
    background-image: url(../../assets/img/mt5-logo.jpg);
  }

  div#pammLogo {
    height: 100px;
    background-image: url(../../assets/img/mt4pamm-logo.jpg);
  }

  button {
    width: 300px;
  }

  div#mt4Inputs,
  div#mt5Inputs,
  div#pammInputs {
    min-height: 200px;
    margin-top: 50px;
  }
}

p#selectPlatformText {
  margin-top: 20px;
  margin-bottom: 0px;
  float: left;

  @media screen and (max-width: $desktop - 1px) {
    float: none;
    text-align: center;
  }
}

span.select {
  margin-top: 5px;
  width: 100%;

  select {
    width: 100%;
  }
}

label.label {
  margin-top: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// CreateDemo.vue?dc4aff68